import { useFindRecord, usePopulate } from 'src/api/APIHooks';

const populateFeeScheduleProgram = (feeScheduleProgram) => {
  const { isLoading: isFSLoading, isSuccess: isFSSuccess } = usePopulate(
    'fee_schedule',
    'fee_schedule',
    feeScheduleProgram,
    { queryConfig: { placeholderData: undefined } },
  );

  const { isLoading: isPOSLoading, isSuccess: isPOSSuccess } = usePopulate(
    'place_of_services',
    'place_of_services',
    feeScheduleProgram,
    { queryConfig: { placeholderData: undefined } },
  );
  const isPOSReady = !feeScheduleProgram?.place_of_services?.length || isPOSSuccess;

  return {
    isPopulationLoading: isFSLoading || isPOSLoading,
    isPopulationSuccess: isFSSuccess && isPOSReady,
  };
};

const populateProgram = (program) => {
  const { isLoading: isFSPLoading, isSuccess: isFSPSuccess } = usePopulate(
    'fee_schedule_program',
    'fee_schedule_program',
    program,
    { queryConfig: { placeholderData: undefined } },
  );
  const feeScheduleProgram = program?.fee_schedule_program;

  const { isPopulationLoading, isPopulationSuccess } = populateFeeScheduleProgram(feeScheduleProgram);

  return {
    isPopulationLoading: isFSPLoading || isPopulationLoading,
    isPopulationSuccess: isFSPSuccess && isPopulationSuccess,
  };
};

export const useFindProgram = (programId) => {
  const { data: programData, isLoading: isProgramLoading, isSuccess: isProgramSuccess } = useFindRecord(
    'program',
    programId,
    { queryConfig: { placeholderData: undefined, enabled: !!programId } },
  );
  const program = programData?.data?.data;

  const { isPopulationLoading, isPopulationSuccess } = populateProgram(program);

  return {
    program,
    isLoading: isProgramLoading || isPopulationLoading,
    isSuccess: isProgramSuccess && isPopulationSuccess,
  };
};
